import type { BoardState, GridPosition } from '../types';
import { BoardModel } from '../models/board/BoardModel';

export function getValidGridPositions(board: BoardState | BoardModel): GridPosition[] {
  const boardState = board instanceof BoardModel ? board.exportState() : board;
  const usableStacks: GridPosition[] = [];
  for (let x = 0; x < boardState.cols; x += 1) {
    for (let y = 0; y < boardState.rows; y += 1) {
      usableStacks.push({ x, y });
    }
  }
  return usableStacks;
}
